import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMessengerFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    viewBox="0 0 14 15"
    {...props}
  >
    <path
      fill="#111"
      d="M7 .797a7 7 0 0 0-6.147 10.35l-.83 2.906a.583.583 0 0 0 .745.714l2.728-.91A7 7 0 1 0 7 .798M4.667 6.63c0-.322.26-.583.583-.583h3.5a.583.583 0 0 1 0 1.167h-3.5a.583.583 0 0 1-.583-.584m.583 1.75h2.333a.583.583 0 1 1 0 1.167H5.25a.583.583 0 0 1 0-1.167"
    />
  </svg>
);
export default SvgMessengerFilledIcon;
